import { render, staticRenderFns } from "./notice-item.vue?vue&type=template&id=df62041e&scoped=true&"
import script from "./notice-item.vue?vue&type=script&lang=js&"
export * from "./notice-item.vue?vue&type=script&lang=js&"
import style0 from "./notice-item.vue?vue&type=style&index=0&id=df62041e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df62041e",
  null
  
)

export default component.exports